import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';

// core components
import PlainNavbar from '../components/PlainNavbar.jsx';
import Footer from '../components/Footer.jsx';

import getAppropriateRoutes from '../routes.js';

import pagesStyle from '../assets/jss/crm/layouts/plainStyle.jsx';

const routes = getAppropriateRoutes('Plain');

class Pages extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'unset';
  }

  getActiveRoute = (routes) => {
    const activeRoute = null;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i];
        }
      }
    }
    return activeRoute;
  };

  getRouteName = (route) => (route ? (route.hideName ? '' : route.name) : 'Alleva CRM');

  getInnerRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getInnerRoutes(prop.views);
      }
      if (prop.layout === '/p') {
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
      } else {
        return null;
      }
    });
  };

  // just inside first <div>: <PlainNavbar brandText={this.getRouteName(activeRoute)} {...rest} />

  render() {
    const { classes, ...rest } = this.props;
    const activeRoute = this.getActiveRoute(routes);
    const innerRoutes = this.getInnerRoutes(routes);
    return (
      <div>
        <PlainNavbar brandText={this.getRouteName(activeRoute)} {...rest} />
        <div className={classes.wrapper} ref="wrapper">
          <div className={classes.fullPage}>
            <Switch>{innerRoutes}</Switch>
            <Footer white />
          </div>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(pagesStyle)(Pages);
